import { useLocation, useNavigate } from "react-router-dom";
import {Container, Typography as Typo } from '@mui/material'
import { useSelector } from "react-redux";
const ErrorPage = () => {
    const state = useSelector((state) => state.userDate);
    const navigate = useNavigate();
    const location = useLocation();
    const userDate = localStorage.getItem('calldetector');
    const pageListAvailable = ['/dashboard','/logs','/utenti','/dispositivi','/settings','/logout']


    const redirect = () =>{
        if(!userDate || !pageListAvailable.includes(location.pathname)) {
        Object.keys(state).length === 0 ? navigate('/') : navigate(-1)
        }
    }
    setTimeout(redirect,3000)

    return (
        <>
<Container>
<Typo align='center' variant='h6'>Redirect in corso...</Typo>
</Container>
        </>
    )

}

export default ErrorPage; 